import e from"./node_modules/style-inject/dist/style-inject.es.js";e("._image-component_i3fb2_1 img{aspect-ratio:var(--image-aspect-ratio);object-fit:var(--image-object-fit)}");
//# sourceMappingURL=image.module.less.js.map
